import { render } from "./NoContent.vue?vue&type=template&id=54c0b445&scoped=true"
import script from "./NoContent.vue?vue&type=script&lang=js"
export * from "./NoContent.vue?vue&type=script&lang=js"

import "./NoContent.vue?vue&type=style&index=0&id=54c0b445&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c0b445"]])

export default __exports__